export const validateMobile = (value) => {
    const errors = TABS.L10n.mobile.parse(value).validate();
    return errors.length ? errors[0] : null;
}

export const validateFnr = (value, format) => {
    const errors = TABS.L10n.nationalNumber.parse(value).validateNationalNumber();
    if (errors.length) {
        return errors[0] + ' (' + format + ')';
    }
    return null;
}

export const validateFirstName = (value, whitelistedValue) => {
    if (value === whitelistedValue) {
        return
    }
    const errors = TABS.L10n.firstName.parse(value).validate();
    if (errors.length) {
        return errors[0];
    }
    if (value.length < 2) {
        return TABS.$t('Ugyldig fornavn');
    }
}
export const validateLastName = (value, whitelistedValue) => {
    if (value === whitelistedValue) {
        return
    }

    const errors = TABS.L10n.lastName.parse(value).validate();
    if (errors.length) {
        return errors[0];
    }
    if (value.length < 2) {
        return TABS.$t('Ugyldig etternavn');
    }
}
export const validateAddress = (value, whitelistedValue) => {
    if (value === whitelistedValue) {
        return
    }

    if (value.length < 2) {
        return TABS.$t('Ugyldig adresse');
    }
}
export const validatePostalCode = (value, whitelistedValue) => {
    if (value === whitelistedValue) {
        return
    }

    const errors = TABS.L10n.zip.parse(value).validate();
    return errors.length ? errors[0] : null;
}
export const validateCity = (value, whitelistedValue) => {
    if (value === whitelistedValue) {
        return
    }
    if (!value.length || value.length < 2) {
        return TABS.$t('Ugyldig sted');
    }
}

export const validateEmail = (value, whitelistedValue) => {
    if (!value) {
        return TABS.$t('Ugyldig e-postadresse');
    }
    if (value === whitelistedValue) {
        return
    }
    if (value.length < 3) {
        return TABS.$t('Ugyldig e-postadresse');
    }

    const errors = TABS.L10n.email.parse(value).validate();
    return errors.length ? errors[0] : null;

}